import * as React from 'react';
import styled from "styled-components";

const Select = styled.select`
    height: 32px;
    box-sizing: border-box;
`;

interface Props {
    emptyLabel?: string;
    values: string[];
    labels?: string[];
    value: string;
    width?: number | string;
    onChange: (value: string) => void;
}

export function FtSelect(props: Props) {
    const {values, labels, value, onChange} = props;

    return (
        <Select value={value}
                style={{width: props.width ?? 120}}
                onChange={e => onChange(e.target.value)}>
            {props.emptyLabel && <option value="">{props.emptyLabel}</option>}
            {values.map((v, i) => (
                <option key={v} value={v}>
                    {labels ? labels[i] : v}
                </option>
            ))}
        </Select>
    );
}